import { z } from 'zod';

export const zoneFormSchema = z
  .object({
    name: z
      .string()
      .trim()
      .min(1, { error: 'shipping:zone.validation.nameRequired' })
      .max(120, { error: 'shipping:zone.validation.nameLength' }),
    countries: z.array(z.string()).min(1, { error: 'shipping:zone.validation.countriesRequired' }),
    /** Country code to region codes for countries the zone covers only in part; a missing key means the whole country. */
    regions: z.record(z.string(), z.array(z.string().min(1).max(20))),
    position: z.coerce
      .number<string | number>()
      .int({ error: 'shipping:zone.validation.position' })
      .min(0, { error: 'shipping:zone.validation.position' }),
  })
  .superRefine((v, ctx) => {
    for (const [country, codes] of Object.entries(v.regions)) {
      if (!v.countries.includes(country)) {
        ctx.addIssue({
          code: 'custom',
          path: ['regions'],
          message: 'shipping:zone.validation.regionsOutsideZone',
        });
        return;
      }
      if (codes.length === 0) {
        ctx.addIssue({
          code: 'custom',
          path: ['regions'],
          message: 'shipping:zone.validation.regionsEmpty',
        });
        return;
      }
    }
  });

export type ZoneFormInput = z.input<typeof zoneFormSchema>;
export type ZoneFormOutput = z.output<typeof zoneFormSchema>;
